export default __webpack_public_path__ + "static/media/ttac3.41e2a832.svg";